import React from 'react'
import { Container, FormInfoWrapper } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { SurgeriesType } from '../../../../types';

const SurgeriesInfo = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);

  return (
    <Container>
      {selectedClient?.surgeries?.length ?
        selectedClient?.surgeries?.map((specialist: SurgeriesType, index: number) => (
          <>
            <p>{`${++index})`}</p>
            <FormInfoWrapper>
              <div>For what?</div>
              <div>{specialist?.forWhat}</div>
            </FormInfoWrapper>
            <FormInfoWrapper>
              <div>When?</div>
              <div>{specialist?.when}</div>
            </FormInfoWrapper>
          </>
        ))
        :
        <em>None</em>
      }
    </Container>
  )
}

export default SurgeriesInfo
